import { useRef, useState } from 'react';

function useProgressiveCount(
  initialValue = 0
): [number | undefined | null, (newValue: number) => void] {
  const [value, setValue] = useState<number | null>(
    initialValue ? initialValue : 0
  );
  const interval = useRef<NodeJS.Timeout | null>(null);
  const stopCondition = useRef<number | null>(null);
  const valueRef = useRef<number | null>(null);
  valueRef.current = value;

  const changeNumber = (newValue: number) => {
    interval.current && clearInterval(interval.current);
    stopCondition.current = newValue;

    const distancia = Math.floor(Math.abs((valueRef.current ?? 0) - newValue));
    const tempo = 300 / distancia;

    interval.current = setInterval(() => {
      const d = (valueRef.current ?? 0) - (stopCondition.current ?? 0);
      if (d === 0) {
        if (interval.current) clearInterval(interval.current);
      } else if (d > 1) {
        setValue((valueRef.current ?? 0) - 1);
      } else if (d < -1) {
        setValue((valueRef.current ?? 0) + 1);
      } else {
        setValue(stopCondition.current);
      }
    }, tempo);
  };

  return [value, changeNumber];
}

export default useProgressiveCount;
